import { render } from "./PivotContents.vue?vue&type=template&id=4e876622&scoped=true"
import script from "./PivotContents.vue?vue&type=script&lang=js"
export * from "./PivotContents.vue?vue&type=script&lang=js"

import "./PivotContents.vue?vue&type=style&index=0&id=4e876622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e876622"],['__file',"src/components/pivot/PivotContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e876622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e876622', __exports__)) {
    api.reload('4e876622', __exports__)
  }
  
  module.hot.accept("./PivotContents.vue?vue&type=template&id=4e876622&scoped=true", () => {
    api.rerender('4e876622', render)
  })

}


export default __exports__